import { defineComponent } from "vue";
export default defineComponent({
  name: "promocode-campaign-card",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  setup: function setup() {
    return {};
  }
});